/* Drag-to-scroll strip for the Scrapbook notes section.
   Pointer drag on any device, momentum fling, snaps to each note (CSS
   scroll-snap), keyboard arrows work, never autoplays. */
(function () {
  function init(strip) {
    if (strip.dataset.dragReady) return;
    strip.dataset.dragReady = "1";
    if (strip.classList.contains("sn__strip--stack")) return stack(strip);
    var down = false,
      startX = 0,
      startLeft = 0,
      lastX = 0,
      lastT = 0,
      vel = 0,
      moved = false,
      raf;

    strip.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      down = true;
      moved = false;
      vel = 0;
      startX = lastX = e.clientX;
      startLeft = strip.scrollLeft;
      lastT = performance.now();
      strip.classList.add("is-dragging");
      strip.style.scrollSnapType = "none";
      cancelAnimationFrame(raf);
    });
    strip.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        try { strip.setPointerCapture(e.pointerId); } catch (_) {}
      }
      strip.scrollLeft = startLeft - dx;
      var now = performance.now();
      vel = (e.clientX - lastX) / Math.max(1, now - lastT);
      lastX = e.clientX;
      lastT = now;
    });
    function up() {
      if (!down) return;
      down = false;
      strip.classList.remove("is-dragging");
      var v = -vel * 16; // px per frame
      (function fling() {
        if (Math.abs(v) < 0.4) {
          strip.style.scrollSnapType = "";
          return;
        }
        strip.scrollLeft += v;
        v *= 0.93;
        raf = requestAnimationFrame(fling);
      })();
    }
    strip.addEventListener("pointerup", up);
    strip.addEventListener("pointercancel", up);
    strip.addEventListener("pointerleave", up);
    // a drag must not count as a click on anything inside
    strip.addEventListener(
      "click",
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true,
    );
    strip.addEventListener("keydown", function (e) {
      var step = strip.clientWidth * 0.6;
      if (e.key === "ArrowRight") {
        strip.scrollBy({ left: step, behavior: "smooth" });
        e.preventDefault();
      }
      if (e.key === "ArrowLeft") {
        strip.scrollBy({ left: -step, behavior: "smooth" });
        e.preventDefault();
      }
    });
  }

  /* Swipe card stack: one review in front, two peeking behind. Drag the front
     card sideways (it leans with the drag) and let go to send it to the back.
     Arrows, keyboard and buttons work too. Vertical swipes still scroll the page. */
  function stack(strip) {
    var sec = strip.closest(".sn");
    var ctrl = sec && sec.querySelector("[data-sn-ctrl]");
    var count = ctrl && ctrl.querySelector(".sn__count");
    var order = [], pos = 0, busy = false;
    var FLY = 380;
    function visible() {
      return [].slice.call(strip.querySelectorAll(".note")).filter(function (n) { return !n.hidden; });
    }
    function layout() {
      order.forEach(function (n, i) {
        n.dataset.depth = i < 3 ? String(i) : "x";
        n.style.zIndex = String(100 - i);
        n.style.transform = "";
        n.setAttribute("aria-hidden", i ? "true" : "false");
      });
      if (count) count.textContent = order.length ? pos + 1 + " / " + order.length : "";
      preloadNext();
    }
    // load the next few photos (and the one before) so a card is never blank when it comes to the front,
    // but only once the stack is close to the screen, so it doesn't slow the first page load
    var near = !("IntersectionObserver" in window);
    function preloadNext() {
      if (!near) return;
      order.slice(0, 4).concat(order.slice(-1)).forEach(function (n) {
        n.querySelectorAll("img[loading='lazy']").forEach(function (img) {
          img.loading = "eager";
          if (img.decode) img.decode().catch(function () {});
        });
      });
    }
    if (!near) {
      var nio = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { near = true; nio.disconnect(); preloadNext(); }
      }, { rootMargin: "800px 0px" });
      nio.observe(strip);
    }
    function reset() { order = visible(); pos = 0; layout(); }
    strip._snReset = reset;
    function next(dir) {
      if (order.length < 2 || busy) return;
      busy = true;
      var top = order[0];
      var from = top.style.transform;
      // bring the next review forward straight away, then fly the old one off on top
      order.push(order.shift());
      pos = (pos + 1) % order.length;
      layout();
      top.dataset.depth = "fly";
      top.style.zIndex = "200";
      top.style.transform = from;
      void top.offsetWidth;
      top.classList.add("is-flying");
      top.style.transform = "translateX(" + dir * 130 + "%) rotate(" + dir * 16 + "deg)";
      top.style.opacity = "0";
      setTimeout(function () {
        top.classList.remove("is-flying");
        top.style.opacity = "";
        layout();
        busy = false;
      }, FLY);
    }
    function prev() {
      if (order.length < 2 || busy) return;
      busy = true;
      var card = order.pop();
      order.unshift(card);
      pos = (pos - 1 + order.length) % order.length;
      card.classList.add("is-drag");
      card.style.transform = "translateX(-130%) rotate(-16deg)";
      card.style.opacity = "0";
      card.style.zIndex = "101";
      void card.offsetWidth;
      card.classList.remove("is-drag");
      card.style.opacity = "";
      layout();
      setTimeout(function () { busy = false; }, FLY);
    }
    var down = false, sx = 0, sy = 0, dx = 0, lx = 0, lt = 0, v = 0, axis = null, tapTarget = null;
    strip.addEventListener("pointerdown", function (e) {
      var top = order[0];
      if (busy || !top || !top.contains(e.target)) return;
      if (e.pointerType === "mouse" && e.button !== 0) return;
      down = true; axis = null; dx = 0; v = 0;
      sx = lx = e.clientX; sy = e.clientY; lt = performance.now(); tapTarget = e.target;
    });
    strip.addEventListener("pointermove", function (e) {
      if (!down) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!axis) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        axis = Math.abs(mx) > Math.abs(my) ? "x" : "y";
        if (axis === "x") { try { strip.setPointerCapture(e.pointerId); } catch (_) {} order[0].classList.add("is-drag"); }
      }
      if (axis !== "x") return;
      dx = mx;
      var now = performance.now();
      v = (e.clientX - lx) / Math.max(1, now - lt);
      lx = e.clientX; lt = now;
      order[0].style.transform = "translateX(" + dx + "px) rotate(" + dx * 0.06 + "deg)";
      var lift = Math.min(1, Math.abs(dx) / 160);
      if (order[1]) order[1].style.transform = "translateY(" + (1.4 - 1.4 * lift) + "rem) scale(" + (0.95 + 0.05 * lift) + ") rotate(" + -3 * (1 - lift) + "deg)";
    });
    function up() {
      if (!down) return;
      down = false;
      var top = order[0];
      if (!top) return;
      top.classList.remove("is-drag");
      if (axis === "x" && (Math.abs(dx) > 50 || Math.abs(v) > 0.35)) next(dx < 0 ? -1 : 1);
      else {
        top.style.transform = ""; if (order[1]) order[1].style.transform = "";
        // a tap (no drag) on the review text opens the full review on phones
        if (!axis && tapTarget && tapTarget.closest(".note__quote")) top.classList.toggle("is-open");
      }
    }
    strip.addEventListener("pointerup", up);
    strip.addEventListener("pointercancel", up);
    strip.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { next(-1); e.preventDefault(); }
      if (e.key === "ArrowLeft") { prev(); e.preventDefault(); }
    });
    if (ctrl) ctrl.addEventListener("click", function (e) {
      var b = e.target.closest(".sn__btn");
      if (!b) return;
      if (b.dataset.dir === "next") next(-1); else prev();
    });
    // one gentle nudge the first time the stack scrolls into view, so people know it swipes
    if ("IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        if (order[0]) {
          order[0].classList.add("is-nudge");
          setTimeout(function () { order[0] && order[0].classList.remove("is-nudge"); }, 1600);
        }
      }, { threshold: 0.6 });
      io.observe(strip);
    }
    reset();
  }
  function filters(root) {
    root.querySelectorAll('.sn__chips').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var sec = bar.closest('.sn'); var strip = sec.querySelector('[data-scrap-drag]');
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('.sn__chip'); if (!b) return;
        bar.querySelectorAll('.sn__chip').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var f = b.dataset.filter;
        strip.querySelectorAll('.note').forEach(function (n) { n.hidden = !(f === 'all' || n.dataset.product === f); });
        if (strip._snReset) strip._snReset(); else strip.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });
  }
  function boot() { filters(document);
    document.querySelectorAll("[data-scrap-drag]").forEach(init);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
